import { Route, Routes, useParams } from 'react-router-dom';
import {
  DashboardPageStateProvider,
  useDashboardPageState,
} from '../../hooks/useDashboardPageState';
import { PhaseDrawer } from './PhaseDrawer';
import { Loader } from '../Loader';
import { UserDashboardPage } from './UserDashboardPage';
import { UserDashboardMainContent } from './UserDashboardMainContent';

const SubRoutes = () => {
  const {
    state: { loading: isFetchingDashboardData },
  } = useDashboardPageState();

  if (isFetchingDashboardData) {
    return <Loader loading={isFetchingDashboardData} />;
  }

  return (
    <>
      <Routes>
        <Route path={'/'} element={<UserDashboardPage />}>
          <Route path={'/'} element={<UserDashboardMainContent />}>
            <Route path={'/phase/:phase'} element={<PhaseDrawer />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export const UserDetailsRoute = () => {
  const { patient } = useParams();

  return (
    <DashboardPageStateProvider patientId={patient}>
      <SubRoutes />
    </DashboardPageStateProvider>
  );
};
